import { ItemCombobox } from '@models-global/model-combobox-item';

export enum Confidence340B {
  LOCATION = '1',
  AFFILIATION = '2'
}

export const MAP_CONFIDENCE_340B: { [key: string]: string } = {
  [Confidence340B.LOCATION]: 'Location',
  [Confidence340B.AFFILIATION]: 'Affiliation'
};

export const ARRAY_CONFIDENCE_340B_OPTIONS: ReadonlyArray<ItemCombobox> =
  Object.values(Confidence340B).map((value) => ({
    text: MAP_CONFIDENCE_340B[value],
    value
  }));
